export enum LoanOriginationSystemProductsFiltersActionTypes {
  SetSearchInputValue = 'loanOriginationSystemProductsFilters/setSearchInputValue',
  SetShowArchived = 'loanOriginationSystemProductsFilters/setShowArchived',
  FilterProductsByMembers = 'loanOriginationSystemProductsFilters/filterProductsByMembers',
  ToggleFiltersPopup = 'loanOriginationSystemProductsFilters/toggleFiltersPopup',
  ChangePopupFilters = 'loanOriginationSystemProductsFilters/changePopupFilters',
  ResetAllFilters = 'loanOriginationSystemProductsFilters/resetAllFilters',
}
